<template lang="pug">
  .main-container.max-content(v-if='!isEmptyObject(resource)')
    vue-headful(:title='viewTitle')
    .resource-title.m-bottom-5
      .column.mobile-hide
        .row.middle.m-bottom-2
          img.resource-logo.mobile-hide(:src='resourceLogo' :alt='resource.category.name' v-if='!!resourceLogo')
          h2.text-big.dark-gray {{ resource.category.name }}
        h1.title-big.dark-gray.bolder {{ resource.title }}
      .column.m-left-2.mobile-show-only
        .color-tag.krea.m-top-2(v-if='isKrea')
        .color-tag.m-top-2(v-else :style='setTagColor')
        h2.text-normal.dark-gray.m-top-1 {{ resource.category.name }}
        h1.title-medium.black.m-top-1 {{ resource.title }}
    student-tab(:sharedClasses='sharedClasses')
</template>

<script>
import { mapState, mapActions } from 'vuex'
import StudentTab from '@/components/Resource/StudentTab'
import amplitude from 'amplitude-js'

import { isEmptyObject } from '../utils/object'
import { tabTitle } from '@/utils/constants'

export default {
  name: 'studentPublicResource',
  components: { StudentTab },
  data() {
    return {
      isEmptyObject,
      sharedClasses: []
    }
  },
  computed: {
    ...mapState({
      resource: state => state.resource.resource,
      shareToken: state => state.resource.shareToken
    }),
    viewTitle() {
      return `${tabTitle} - ${this.resource.title}`
    },
    resourceLogo() {
      return this.resource.category ? this.resource.category.imageURL : ''
    },
    setTagColor() {
      return {
        '--tag-color': this.resource.category.color
      }
    },
    isKrea() {
      return this.resource.category.name === 'Krea'
    },
    hasTrigger() {
      return (
        this.resource.mediaSummary ||
        this.resource.studentPedagogicalGoal ||
        this.resource.hasMedia
      )
    }
  },
  watch: {
    shareToken() {
      this.hydrateStudentResource({ id: this.$route.params.id, token: this.shareToken })
    },
    resource(nextResource, prevResource) {
      if ((!prevResource.id || prevResource.id !== nextResource.id) && nextResource.id) {
        amplitude.getInstance().logEvent('Resource Student Public Access', {
          id: nextResource.id,
          name: nextResource.title,
          category: nextResource.category.name
        })
      }
    }
  },
  async created() {
    const id = this.$route.params.id
    const token = this.$route.query.verify

    if (token && !!this.resource) {
      await this.hydrateStudentResource({ id, token })
    } else if (this.shareToken) {
      await this.hydrateStudentResource({ id, token: this.shareToken })
    } else {
      await this.getShareableLink(id)
    }

    if (this.$route.query.sharedClasses) {
      const classes = this.$route.query.sharedClasses
      classes.split(',').map(cn => Number(cn))
      this.sharedClasses = classes
    }
  },
  methods: {
    ...mapActions([
      'hydrateStudentResource',
      'getShareableLink',
      'changeInnerLocale'
    ])
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';
@import 'src/scss/variables/sizes';

.main-container {
  margin: 50px auto;
  min-height: calc(100vh - #{$navbar-height});
}

.resource-logo {
  margin-right: 10px;
  width: 35px;
}

.resource-title {
  border-bottom: 7px solid $light-gray;
  padding-bottom: 35px;
  margin-bottom: 45px;
}

.mobile-show-only {
  display: none;
}

@media screen and (max-width: $mobile-break) {
  .mobile-hide {
    display: none;
  }

  .main-container {
    margin: 0 auto 50px;
    position: relative;
    top: 65px;
  }

  .resource-title {
    border-bottom: 0;
    margin-bottom: 0;
  }

  .color-tag {
    height: 10px;
    max-width: 38px;
  }

  .authors {
    height: 36px;
    width: 36px;
  }

  .mobile-show-only {
    display: flex;
  }
}
</style>
